module.exports = __webpack_public_path__ + "img/Airbnb-Office-Everyday-Stretches-Shoulder.65e4f35c.jpg";